import { TreeNodeModel } from '@creditsights/styleguide-web';
import { omit, orderBy } from 'lodash';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const filterMapper = (array: string[]) => orderBy(array).map((item) => ({ key: item, title: item }));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getOptionsWithTwoLevels = (options: TreeNodeModel[]) =>
  options.map((option) => ({
    ...option,
    children: option.children?.map((c) => omit(c, 'children')),
  }));
